import TypeBasculeFormController from './type.bascules.form.controller';

export default {
    template: require('./type.bascules.form.html'),
    controller: TypeBasculeFormController
};
